export interface Storage {
    id: string
    companyId: string
    name: string
    archived: boolean
    createdAt: number
    updatedAt: number
}

export const toStorageMap = (storages: Storage[]): Map<string, Storage> =>
    new Map(storages.map(s => [s.id, s]))

export const validateSelectableStorageId = (
    storages: Storage[],
    storageId: string
): string | undefined => {
    if (storageId === "") {
        return undefined
    }

    const storage = storages.find(s => s.id === storageId)
    if (!storage) {
        return "倉庫IDが見つかりません"
    }
    if (storage.archived) {
        return `アーカイブ済みの倉庫(${storage.name})は指定できません`
    }

    return undefined
}
